uniform float uTime;
uniform float uSize;
uniform vec2 uResolution;
uniform vec2 uMouse;

uniform vec2 uFrequency;
uniform float uElevation;
uniform float uSpeed;

uniform float uNoiseFrequency;
uniform float uNoiseSpeed;
uniform float uNoiseFlow;

uniform float uInteractState;

varying float vWave;

#include ../includes/simplexNoise4d.glsl

void main() {

    // World position
    vec4 anchor = modelMatrix * vec4(position, 1.0);

    // Radial falloff
    float dist = length(anchor.xz);
    float falloff = 1.0 - smoothstep(6.0, 7.5, dist);

    // Noise
    float noise = simplexNoise4d(vec4(
        anchor.x * uNoiseFrequency,
        anchor.z * uNoiseFrequency,
        0.0,
        uTime * uNoiseSpeed
    ));
    noise = noise * 0.5 + 0.5;

    // Base wave
    float baseWave =
        sin(anchor.x * uFrequency.x + uTime * uSpeed) *
        cos(anchor.z * uFrequency.y + uTime * uSpeed);

    float elevation =
        baseWave *
        uElevation *
        mix(1.0 - uNoiseFlow, 1.0 + uNoiseFlow, noise);

    // Screen-space mouse interaction
    vec4 viewPos = viewMatrix * vec4(
        anchor.xyz + vec3(0.0, elevation * falloff, 0.0),
        1.0
    );

    vec4 clipPos = projectionMatrix * viewPos;
    vec2 screenPos = clipPos.xy / clipPos.w;

    float aspect = uResolution.x / uResolution.y;
    vec2 corrected = vec2(aspect, 1.0);

    float mouseDist = distance(screenPos * corrected, uMouse * corrected);
    float interaction = pow(smoothstep(1.5, 0.0, mouseDist), 1.5);

    if (interaction > 0.001 && uInteractState < 0.5) {
        elevation += interaction * 0.25;
    }

    // Final position
    vec3 finalPos = anchor.xyz + vec3(0.0, elevation * falloff, 0.0);
    gl_Position = projectionMatrix * viewMatrix * vec4(finalPos, 1.0);

    // -------------------------
    // POINT SIZE (KEY FIX)
    // -------------------------
    float depth = clamp(-viewPos.z, 2.0, 20.0);

    gl_PointSize = uSize * 260.0;
    gl_PointSize *= mix(1.2, 0.6, depth / 20.0);
    gl_PointSize *= falloff;

    vWave = elevation;
}
